/* Imports */
import React, { useState } from "react"
import { useParams } from "react-router-dom"
import { unslugify } from "js-utils-julseb"
import { Font, Button, Grid, Input } from "fajny-react"
import { v4 as uuid } from "uuid"

import NotFound from "./NotFound"

import PageLayout from "../components/PageLayout"

import routes from "../routes"

const ListPage = () => {
    const { category } = useParams()
    const categories = ["styles", "layouts", "components", "helpers"]

    const filteredRoutes = routes.filter(
        route => route.path.split("/")[1] === category
    )

    const [search, setSearch] = useState("")
    const handleSearch = e => setSearch(e.target.value)
    const clearSearch = () => setSearch("")

    const results = filteredRoutes.filter(route =>
        route.path.toLowerCase().includes(search.toLowerCase())
    )

    const intros = [
        {
            name: "styles",
            text: "Fajny CSS uses its own styles for the colors and fonts.",
        },
        {
            name: "layouts",
            text: "The most basic elements. Build your website with the container, sections and grids.",
        },
        {
            name: "components",
            text: "All the components for Fajny CSS.",
        },
        {
            name: "helpers",
            text: "Helpers are CSS classes and Styled components mixins created to help you ease the development.",
        },
    ]

    const filterIntro = intros.filter(intro => intro.name === category)
    const intro = filterIntro[0]?.text

    return !categories.includes(category) ? (
        <NotFound />
    ) : (
        <PageLayout title={unslugify(category)}>
            <Font.H1>{unslugify(category)}</Font.H1>

            <Font.P>{intro}</Font.P>

            <Grid col={3} gap="s">
                <Input
                    fajnyIcon="magnifying-glass-solid"
                    type="search"
                    placeholder="Search component..."
                    onChange={handleSearch}
                    value={search}
                    clearSearch={clearSearch}
                    id="search"
                />
            </Grid>

            {results.length > 0 ? (
                <Grid col={3} gap="s">
                    {results.map(route => (
                        <Button to={route.path} key={uuid()}>
                            {unslugify(route.path.split("/")[2])}
                        </Button>
                    ))}
                </Grid>
            ) : (
                <Font.P>Your search did not return any result!</Font.P>
            )}
        </PageLayout>
    )
}

export default ListPage
